import { render } from "./AssignAddonsResultModal.vue?vue&type=template&id=3caed390&scoped=true&ts=true"
import script from "./AssignAddonsResultModal.vue?vue&type=script&lang=ts"
export * from "./AssignAddonsResultModal.vue?vue&type=script&lang=ts"

import "./AssignAddonsResultModal.vue?vue&type=style&index=0&id=3caed390&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caed390"]])

export default __exports__